import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ProductApi} from "../../../../common/apis/product-api";
import {Product} from "../../../../common/interfaces/Product";

@Component({
  selector: 'popular-dishes',
  templateUrl: './popular-dishes.component.html',
  styleUrls: ['./popular-dishes.component.scss']
})
export class PopularDishesComponent implements AfterViewInit, OnInit {
  @ViewChild('featuredItemsContainer') container: ElementRef

  imageSrc = "assets/logo.svg"

  products: Product[] = []


  constructor(
    private productApi: ProductApi
  ) {
  }

  ngOnInit(): void {
    this.productApi.getAllProducts().subscribe({
      next: (productsResponse) => {
        this.products = productsResponse.data
        if (this.products.isNotEmpty()) {
          while (this.products.length < 10) {
            this.products.push(...productsResponse.data)
          }
        }
      }
    })
  }

  ngAfterViewInit(): void {
    let previousPosition = this.container.nativeElement.scrollLeft
    let currentPosition = this.container.nativeElement.scrollLeft
    setInterval(() => {
      previousPosition = this.container.nativeElement.scrollLeft
      this.container.nativeElement.scrollLeft += 1
      currentPosition = this.container.nativeElement.scrollLeft
      if (previousPosition === currentPosition) {
        this.container.nativeElement.scrollLeft = 0
      }
    }, 50);
  }
}
